"use client";

import { Box } from "@mui/material";
import { actionSx } from "@/src/components/common/broadsheet/tokens";
import {
  articleCitationRecord,
  downloadBibTex,
  downloadRis,
} from "@/src/utils/export";

const CitationButton = ({
  onClick,
  label,
}: {
  onClick: () => void;
  label: string;
}) => (
  <Box
    component="button"
    type="button"
    onClick={onClick}
    className="bf-ui"
    sx={{
      ...actionSx("outline", "small"),
      width: "100%",
      mb: 0.5,
      justifyContent: "flex-start",
      cursor: "pointer",
    }}
  >
    {label}
  </Box>
);

export default function ArticleCitationFiles({
  article,
  journal,
  publisher,
  journalAbbr,
  articleId,
}: {
  article: Article;
  journal: Journal;
  publisher?: string;
  journalAbbr: string;
  articleId: number;
}) {
  const record = () =>
    articleCitationRecord({
      article,
      journal,
      publisher,
      journalAbbr,
      articleId,
    });

  return (
    <Box sx={{ mb: 0.5 }}>
      <CitationButton
        onClick={() => downloadRis(record())}
        label="Import into EndNote"
      />
      <CitationButton
        onClick={() => downloadBibTex(record())}
        label="Import into BibTex"
      />
    </Box>
  );
}
